<template>
  <modal  :title="title"  :active.sync="active" :classModal="''">
    <div slot="header">
      <div class="vx-row flex justify-center m-2">
        <h3 class>Data Loket</h3>
      </div>
    </div>
    <global-wrapper :loading="loading">
      <div class="vx-row m-0">
        <div class="flex flex-col w-full justify-center p-5 pb-0">
          <div class="w-full text-center  font-medium text-xl">
            {{counter.service_name}}
          </div>
          <div class="w-full text-center text-lg">
            {{counter.counter_name}}
          </div>
          <div class="w-full flex flex-col justify-center items-center py-5 pb-0" v-if="counter.on_service != null">
            <vs-avatar size="70px" class="mb-3" :src="counter.on_service.avatar"/>
            <span class="text-lg mt-5">{{counter.on_service.username}}</span>
            <div class="flex my-2">
              <vs-icon v-for="item in userRating" :key="item" icon-pack="feather" class="mr-1" icon="icon-star" />
            </div>
          </div>
          <div class="w-full flex flex-col justify-center items-center py-5 pb-0" v-else>
            <vs-avatar size="70px" class="mb-3" src=""/>
            <span class="text-sm mt-5">Mohon ditunggu, sebentar lagi petugas kami akan segera melayani antrian.</span>
          </div>
          <div class="w-full text-center text-base">
            <div class="flex flex-col items-center mb-3">
            </div>
          </div>
        </div>
        <div class="flex flex-row w-full justify-between p-5 pt-0" v-if="counter.on_service != null">
          <div class="flex flex-col m-5 items-center">
            <div class="text-2xl text-primary">
              {{counter.on_service.ticket_code}}
            </div>
            <div>
              Sedang Melayani
            </div>
          </div>
          <div></div>
          <div class="flex flex-col m-5 items-center">
            <div class="text-2xl text-primary">
              {{userPerDayService}}
            </div>
            <div>
              Telah Melayani
            </div>
          </div>
        </div>
      </div>
    </global-wrapper>
  </modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue';
export default {
  name: "popup-counter-detail",
  components : {
    Modal
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default : false
    },
    title:  {
      type: String,
      required: false,
      default : ''
    },
    counter : {
      required : true
    }
  },
  data() {
    return {
      loading : false,
      userRating: 0,
      userPerDayService: 0
    };
  },
  watch : {
    active : function(){
      this.$emit('update:active', this.active);
      if(this.active == true && this.counter.on_service != null){
        this.getCounterDetail();
      }
    }
  },
  methods : {
    getCounterDetail() {
      this.loading = true;
      this.$http
      .get(`/app/queue/active-queue/counter-detail/${this.counter.on_service.user_id}/${this.counter.on_service.date_book}`)
      .then(r => {
        this.userRating = r.data.data.user_rating;
        this.userPerDayService = r.data.data.user_perday_service;
        this.loading = false;
      })
      .catch(e => {
        this.parseError(e);
        this.loading = false;
      });
    },
  },
}
</script>